export const REMOTIVE_URL = "https://remotive.io/api/remote-jobs?";
